import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './log.scss'

// Actions
import { GetLog, GetOrderNotifications } from '../../../../actions/orders'

// Components
// import HelpText from '../../../../shared/components/HelpText'
import Header from '../../../../shared/components/Header'

// Utils
import { renderFullDate } from '../../../../utils/time'
import { translation } from '../../../../utils/helpers'
import { hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../utils/auth'

// Elements
// import TabBar from '../../../../shared/elements/tabBar'
import Col from '../../../../shared/elements/col'
import Panel from '../../../../shared/elements/panel'
import Grid from '../../../../shared/elements/grid'
import LabelWrapper from '../../../../shared/elements/labelWrapper'

class Log extends Component {

  constructor (props) {
    super(props)
    this.state = {
      log: [{
        ChangedByShopName: '',
        ChangedBy: '',
        ChangedByRole: 0,
        ChangedByMail: '',
        ChangedByMobile: '',
        Date: undefined,
        TypeDictionaryKey: 0,
        ValueDictionaryKey: 0,
        ValueParameters: []
      }],
      notifications: [{
        UserName: '',
        SendTime: undefined,
        MessageType: 0,
        EventType: 0
      }]
    }
    this.getOrderLog = this.getOrderLog.bind(this)
    this.getOrderNotifications = this.getOrderNotifications.bind(this)
  }

  componentDidMount () {
    this.getOrderLog()
    this.getOrderNotifications()
  }

  getOrderLog () {
    this.props.GetLog(this.props.router.params.orderID).then((res) => {
      this.setState({
        log: res.data
      })
    }, () => {
      window.toastr.error(translation('2212'), translation('216'))
    })
  }

  getOrderNotifications () {
    if (!hasSubscriptionPermission(this.props.auth, 20) && !hasPartnerSubscriptionPermission(this.props.auth, 20)) return null
    this.props.GetOrderNotifications(this.props.router.params.orderID).then((res) => {
      this.setState({
        notifications: res.data
      })
    }, () => {
      window.toastr.error(translation('2213'), translation('216'))
    })
  }

  renderOrderLog () {
    const cols = [ 1.2, 1, 2.5 ]
    let log = this.state.log
    let hasData = log !== undefined

    const getLogLineText = (item, key) => {
      if (item === '<br />') return <br />
      return (
        <div key={key} dangerouslySetInnerHTML={{__html: item}} />
      )
    }

    const getTranslatedLogLineText = (item, key) => {
      if (item === '<br />') return <br key={key} />
      return translation(item)
      // return (
      //   <div key={key} dangerouslySetInnerHTML={{__html: translation(item)}} />
      // )
    }
    const getDescriptionText = (item) => {
      var value = ''
      var returnValueParam = false
      var translateValueParam = false
      if (item.ValueDictionaryKey > 0) {
        value = translation(item.ValueDictionaryKey)
      } else {
        translateValueParam = true
      }

      if (item.ValueParameters && item.ValueParameters.length > 0) {
        for (let i = 0; i < item.ValueParameters.length; i++) {
          if (item.ValueParameters[i].includes('{stop}')) {
            item.ValueParameters[i] = item.ValueParameters[i].replace('{stop}', '')
            value = ''
          }
        }
      }
      if (item.ValueParameters && value.includes('{0}')) {
        for (let i = 0; i < item.ValueParameters.length; i++) {
          if (value.includes('{' + i + '}')) {
            value = value.replace('{' + i + '}', item.ValueParameters[i])
          }
        }
      } else {
        returnValueParam = true
      }

      return (
        <div className='description'>
          {value}
          {returnValueParam ? translateValueParam ? '' : <br /> : ''}
          {item.ValueParameters && (returnValueParam ? translateValueParam ? item.ValueParameters.map(getTranslatedLogLineText) : item.ValueParameters.map(getLogLineText) : '')}
        </div>
      )
    }

    const renderLogLine = (val, key) => {
      let shopName = ''
      let roleName = ''
      if (val.ChangedByShopName) {
        shopName = val.ChangedByShopName
        roleName = '\n'
      }
      if (val.ChangedByRole !== 0 && val.ChangedByRole !== 100) roleName += translation(this.props.roleType[val.ChangedByRole])
      let mailAndPhone = ''
      if (val.ChangedByMail) mailAndPhone = '\n' + val.ChangedByMail
      if (val.ChangedByMobile) mailAndPhone += '\n' + val.ChangedByMobile

      return (
        <li key={key}>
          <Grid cols={cols}>
            <div className='date'>{renderFullDate(val.Date)}</div>
            <div className='user'>
              <LabelWrapper labelText={val.ChangedBy} helpText={roleName && shopName + roleName + mailAndPhone} />
            </div>
            <div className='text'>
              <div className='full'>
                {val.TypeDictionaryKey && (translation(val.TypeDictionaryKey))}
              </div>
              {getDescriptionText(val)}
            </div>
          </Grid>
        </li>
      )
    }

    return (
      <Panel title={translation('2211')}>
        <ul>
          <li>
            <Grid cols={cols}>
              <LabelWrapper labelText={translation('388')} />
              <LabelWrapper labelText={translation('30')} />
              <LabelWrapper labelText={translation('1021')} />
            </Grid>
          </li>
          {hasData && (log.map(renderLogLine))}
        </ul>
      </Panel>
    )
  }

  renderNotificationsLog () {
    if (!hasSubscriptionPermission(this.props.auth, 20) && !hasPartnerSubscriptionPermission(this.props.auth, 20)) return null
    let log = this.state.notifications
    let hasData = log !== undefined
    const cols = [ 2, 2, 1, 4 ]

    const renderLogLine = (val, key) => {
      let messageTypeText = ''

      let eventText = translation(this.props.notificationEventType[val.EventType])

      switch (val.MessageType) {
        case 0:
          messageTypeText = translation('15')
          break
        case 1:
          messageTypeText = translation('151')
          break
      }

      return (
        <li key={key}>
          <Grid cols={cols} spacing={2}>
            <div className='date'>{renderFullDate(val.SendTime)}</div>
            <div className='user'>{val.UserName}</div>
            <div className='messagetype'>{messageTypeText}</div>
            <div className='eventtype'>{eventText}</div>
          </Grid>
        </li>
      )
    }

    return (
      <Panel title={translation('13461')}>
        <ul>
          <li>
            <Grid cols={cols}>
              <LabelWrapper labelText={translation('388')} />
              <LabelWrapper labelText={`${translation(30)}/${translation(1052)}`} />
              <LabelWrapper labelText={translation('332')} />
              <LabelWrapper labelText={translation('1021')} />
            </Grid>
          </li>
          {hasData && (log.map(renderLogLine))}
        </ul>
      </Panel>
    )
  }

  render () {
    return (
      <div className='log__screen clearfix'>
        {!this.props.disabled && (
          <Header
            router={this.props.router}
            showBack
            headerButtonsGoBack={this.props.renderButtonsGoBack}
            renderButtons={() => { return [] }}
            >
            {this.props.renderTabs()}
          </Header>
          )}
        <Col span='3'>
          {this.renderOrderLog()}
        </Col>
        <Col span='3'>
          {this.renderNotificationsLog()}
        </Col>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    order: state.orders.order,
    roleType: state.common.enums_new.AccessLevels,
    notificationEventType: state.common.enums_new.NotificationEventType
  }
}

export default connect(mapStateToProps, {
  GetLog,
  GetOrderNotifications
})(Log)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/Log/index.js